module.exports = __webpack_public_path__ + "static/media/unverified.9b1784f3.svg";